/* 
Author:Lamiaa Moustafa
Desc: Dashboard component "protected routes"
*/ 
import React from 'react'
import { Outlet } from 'react-router-dom';
import { Footer1st2911 } from '../../components/Footer1st2911';
 import { Nav1st2911 } from '../../components/Nav1st2911';


const Dashboard = () => {
  return (
  <>
  <Nav1st2911/>
    <Outlet/>
    <Footer1st2911/>
    </>
  )
}
export default Dashboard;